'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseIcons = require('@bibliocommons/base-icons');

var Icons = _interopRequireWildcard(_baseIcons);

require('../styles/Checkbox.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = exports.Checkbox = function (_BcReactComponent) {
  _inherits(Checkbox, _BcReactComponent);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this.bindAll('setCheckbox', 'handleChange');
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'setCheckbox',
    value: function setCheckbox(el) {
      this._checkbox = el;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      e.preventDefault();
      if (!this._checkbox) {
        return;
      }

      var _props = this.props,
          handleChange = _props.handleChange,
          name = _props.name,
          value = _props.value,
          checked = _props.checked;

      handleChange(!checked, {
        name: name,
        value: value
      });
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      return _react2.default.createElement(
        'label',
        {
          id: 'label_' + this.props.id,
          htmlFor: this.props.id,
          'data-test-id': this.props.labelTestId,
          className: (0, _classnames2.default)('checkbox-label', {
            'label-before': this.props.labelBefore,
            'sr-only': this.props.srOnlyLabel,
            'disabled-label': this.props.disabled
          }) },
        this.props.label
      );
    }
  }, {
    key: 'renderFakeCheckbox',
    value: function renderFakeCheckbox() {
      var _this2 = this;

      var IconName = Icons[this.props.checked ? this.props.checkedIconName : this.props.uncheckedIconName];
      var iconProps = this.props.checked ? this.props.checkedIconProps : this.props.uncheckedIconProps;
      var buttonClassName = (0, _classnames2.default)('check', { 'no-borders': this.props.hideBorders, 'hide-icon': !IconName, 'checkbox-disabled': this.props.disabled });
      var iconClassName = (0, _classnames2.default)('checkbox-icon', iconProps.className);
      var setFocusElement = function setFocusElement(el) {
        _this2._focusableElement = el;
      };

      if (!IconName) {
        // We have to do this so the lack of icon doesn't cause "jumps" when you toggle between visible icon and no icon
        IconName = Icons[this.props.checkedIconName];
      }

      return _react2.default.createElement(
        'button',
        { type: 'button', className: buttonClassName, role: 'checkbox', 'aria-checked': this.props.checked, 'aria-labelledby': 'label_' + this.props.id, onClick: this.handleChange, ref: setFocusElement },
        IconName && _react2.default.createElement(IconName, _extends({}, iconProps, { className: iconClassName }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          labelBefore = _props2.labelBefore,
          inline = _props2.inline,
          variant = _props2.variant,
          className = _props2.className,
          props = _objectWithoutProperties(_props2, ['labelBefore', 'inline', 'variant', 'className']); // eslint-disable-line no-unused-vars

      // Remove unused props before spreading


      delete props.label;
      delete props.checkedIconName;
      delete props.checkedIconProps;
      delete props.uncheckedIconName;
      delete props.uncheckedIconProps;
      delete props.handleChange;
      delete props.labelTestId;
      delete props.hideBorders;
      delete props.srOnlyLabel;

      var classNames = (0, _classnames2.default)('cp-checkbox', { 'inline-checkbox': inline }, 'checkbox-variant-' + variant);

      return _react2.default.createElement(
        'div',
        { className: classNames },
        labelBefore && this.renderLabel(),
        !this.props.disabled && _react2.default.createElement('input', _extends({
          type: 'checkbox',
          ref: this.setCheckbox,
          className: (0, _classnames2.default)('checkbox-input', className),
          onChange: this.handleChange,
          'aria-hidden': true
        }, props)),
        this.renderFakeCheckbox(),
        !labelBefore && this.renderLabel()
      );
    }
  }]);

  return Checkbox;
}(_baseBcReactComponent2.default);

Checkbox.propTypes = {
  /**
   * id property for the checkbox. required for accessibility.
   */
  id: _react.PropTypes.string.isRequired,
  /**
   * Additional classes to pass to the checkbox container
   */
  className: _react.PropTypes.string,
  /**
   * Label should appear before Checkbox
   */
  labelBefore: _react.PropTypes.bool,
  /**
   * Label for the checkbox. Required for accessibility.
   */
  label: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node, _react.PropTypes.string]).isRequired,
  /**
   * Name for the checkbox. Required for accessibility.
   */
  name: _react.PropTypes.string,
  /**
   * Whether or not the checkbox is disabled
   */
  disabled: _react.PropTypes.bool,
  /**
   * Function that gets called when the checkbox is checked/unchecked
   * Function signature is `(checked : boolean, { name : string, value : string }) => void`
   */
  handleChange: _react.PropTypes.func,
  /**
   * Value to be passed to handleChange when checkbox is checked / unchecked
   */
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _reactImmutableProptypes2.default.map]),
  /**
   * If the checkbox is checked or not
   */
  checked: _react.PropTypes.bool,
  /**
   * Checked by default
   */
  defaultChecked: _react.PropTypes.bool,
  /**
   * Icon to be used when checkbox is checked
   */
  checkedIconName: _react.PropTypes.string,
  /**
   * Props to be passed to the icon when checkbox is checked
   */
  checkedIconProps: _react.PropTypes.objectOf(_react.PropTypes.string, _react.PropTypes.any),
  /**
   * Icon to be used when checkbox is unchecked
   */
  uncheckedIconName: _react.PropTypes.string,
  /**
   * Props to be passed to the icon when checkbox is unchecked
   */
  uncheckedIconProps: _react.PropTypes.objectOf(_react.PropTypes.string, _react.PropTypes.any),
  /**
   * Checkbox should be displayed inline
   */
  inline: _react.PropTypes.bool,
  /**
   * Variant of the checkbox. It must be defined in the CSS.
   */
  variant: _react.PropTypes.oneOf(['primary', 'default', 'transparent']),
  /**
   * Hide borders on the checkbox
   */
  hideBorders: _react.PropTypes.bool,
  labelTestId: _react.PropTypes.string,
  srOnlyLabel: _react.PropTypes.bool
};

Checkbox.defaultProps = {
  checked: false,
  checkedIconName: 'Checkmark',
  checkedIconProps: {},
  uncheckedIconProps: {},
  handleChange: function handleChange() {},

  inline: false,
  labelBefore: false,
  disabled: false,
  hideBorders: false,
  variant: 'primary',
  srOnlyLabel: false
};

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-checkbox/lib/components/Checkbox.component.js
// module id = 1180
// module chunks = 0